<template>
    <section-con main="了解学生才能更好的因材施教" sub="洞察学生学习情况，真正实施因材施教">
        <div class="aptitude-box">
            <div class="aptitude-item">
                <img class="img-step" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/step1.png">
                <p class="sub-title">洞察学生学习情况</p>
                <div class="middle">
                    <div class="img-box">
                        <img class="second-img" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-2-4.png">
                    </div>
                    <p class="seconde-mes">老师教学能力</p>
                </div>
                <div class="bottom">
                    <div class="bottom-item">
                        <div class="bottom-img-bx">
                            <img class="bottom-img img4" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-2-6.png">
                        </div>
                        <p class="bottom-mes">视觉识别</p>
                    </div>
                    <div class="bottom-item">
                        <div class="bottom-img-bx">
                            <img class="bottom-img img3" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-2-5.png">
                        </div>
                        <p class="bottom-mes">听觉识别</p>
                    </div>
                </div>
            </div>
            <div class="aptitude-item">
                <img class="img-step" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/step2.png">
                <p class="sub-title">实施教学决策</p>
                <div class="middle">
                    <div class="img-box">
                        <img class="second-img spc" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-2-1.png">
                    </div>
                    <p class="seconde-mes">教学大脑辅助</p>
                </div>
                <div class="bottom">
                    <div class="bottom-item">
                        <div class="bottom-img-bx">
                            <img class="bottom-img img1" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-2-2.png">
                        </div>
                        <p class="bottom-mes">教学内容</p>
                    </div>
                    <div class="bottom-item">
                        <div class="bottom-img-bx">
                            <img class="bottom-img img2" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ai-2-3.png">
                        </div>
                        <p class="bottom-mes">教学方法</p>
                    </div>
                </div>
            </div>
        </div>
    </section-con>
</template>
<script>
export default {
    props: {
        vm: {
            type: Object,
            default: () => {}
        }
    }
}
</script>
<style lang="scss" scoped>
.aptitude-box{
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .aptitude-item{
        width: 162px;
        background:rgba(248,249,253,1);
        border-radius:4px;
        padding: 10px 10px 17px;
        color:#282828;
        .img-step{
            display: block;
            width: 31px;
            height: 18px;
        }
        .sub-title{
            margin-top: 4px;
            font-size:12px;
            font-family:PingFangSC-Semibold,PingFang SC;
            font-weight:600;
            line-height:17px;
            text-align: left;
        }
        .middle{
            margin: 23px auto 0px;
            .img-box{
                width: 91px;
                height: 54px;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                .second-img{
                    width: 100%;
                    height: 100%;
                    &.spc{
                        width: 82px;
                        height: 49px;
                    }
                }
            }
            .seconde-mes{
                margin-top: 18px;
                font-size:12px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                line-height:17px;
            }
        }
        .bottom{
            margin-top: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            .bottom-item{
                margin-right: 30px;
                .bottom-img-bx{
                    width: 35px;
                    height: 28px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .img1{
                        width: 28px;
                        height: 27px;
                    }
                    .img2{
                        width: 24px;
                        height: 24px;
                    }
                    .img3{
                        width: 35px;
                        height: 26px;
                    }
                    .img4{
                        width: 24px;
                        height: 28px;
                    }
                }
                .bottom-mes{
                    margin-top: 14px;
                    font-size:10px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    line-height:14px;
                }
                &:last-of-type{
                    margin-right: 0px;
                }
            }
        }
    }
}
</style>